// Basket rows start at row 2; the totals row sits directly below them.
export const SECURITY_ROW_OFFSET = 2;

// The Target Value total follows the basket rows until the user types a value into it. Both the
// parser (which builds the cell) and the approach (which restores the link after a row edit) need
// the identical expression, so it is built here rather than spelled out twice.
const getTargetValueSumExpr = (basketLength: number) => {
  const cellRefs = Array.from({ length: basketLength }, (_, index) => `D${index + SECURITY_ROW_OFFSET}`).join(',');
  return `=SUM(${cellRefs})`;
};

export default getTargetValueSumExpr;
